import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import LxcError from "~/core/models/LxcError.class";
import licenseService from "~/modules/license/services/license.service";

export function useUploadLicense(organizationCode?: number) {
  const error: Ref<LxcError | undefined> = ref();
  const isLoading = ref(false);

  const { can } = useAcl();

  async function uploadLicense(
    licenseFile: File,
    progress: Ref<number | undefined | null>,
  ) {
    isLoading.value = true;
    error.value = undefined;

    const response = await licenseService.uploadLicenseFile(
      licenseFile,
      progress,
      organizationCode,
    );

    if (LxcError.check(response)) {
      error.value = response;
    }
    isLoading.value = false;
  }

  function canUploadLicense() {
    return can(ACLRoles.CAN_WRITE_LICENSE);
  }

  return {
    isLoading,
    error,
    uploadLicense,
    canUploadLicense,
  };
}
